// extracted by mini-css-extract-plugin
export var active = "_5o-a";
export var activeIndicator = "_5o-9";
export var disabled = "_5o-b";
export var fullWidth = "_5o-2";
export var lg = "_5o-7";
export var md = "_5o-6";
export var redoButtonTabGroup = "_5o-0";
export var sm = "_5o-5";
export var tabButton = "_5o-4";
export var tabButtonsContainer = "_5o-1";
export var themeDestructive = "_5o-d";
export var themeNormal = "_5o-c";
export var themeSuccess = "_5o-e";
export var xl = "_5o-8";
export var xs = "_5o-3";